module.exports = __webpack_public_path__ + "img/female.7e5cffb9.png";